<div class="chart">
    <apx-chart
        [series]="chartOptions.series!"
        [chart]="chartOptions.chart!"
        [xaxis]="chartOptions.xaxis!"
        [markers]="chartOptions.markers!"
        [stroke]="chartOptions.stroke!"
        [yaxis]="chartOptions.yaxis!"
        [dataLabels]="chartOptions.dataLabels!"
        [title]="chartOptions.title!"
        [grid]="chartOptions.grid!"
        [fill]="chartOptions.fill!"
        [tooltip]="chartOptions.tooltip!"
        [legend]="chartOptions.legend!"
    ></apx-chart>
</div>